import { Injectable } from '@angular/core';
import { Http, L10n, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { OrderStatusesQuery, OrderStatusesQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(OrderStatusesQuery)
@Wrapper(OrderStatusesQueryHandlerBase)
export class OrderStatusesQueryHandler {
    public constructor(
        http: Http,
        l10n: L10n
    ) { }
}